module.exports = __webpack_public_path__ + "media/icons/arrow-left-square-340dc7ba.png";